class SmoothScroll {
  constructor() {
    this.hamburger = null;
    this.init();
  }

  init() {
    // まず全てのaタグを確認
    const allLinks = document.querySelectorAll('a');
    // console.log('All links found:', allLinks.length);
    
    // ページ内リンクを取得（複数のセレクタで試す）
    const internalLinks1 = document.querySelectorAll('a[href^="#"]:not([href="#"])');
    const internalLinks2 = document.querySelectorAll('a[href*="#"]');
    const internalLinks3 = document.querySelectorAll('.g-navigation-unit__inner, .g-menu-navigation-unit__inner');
    
    // console.log('Links with href^="#":', internalLinks1.length);
    // console.log('Links with href*="#":', internalLinks2.length);
    // console.log('Navigation links:', internalLinks3.length);
    
    // 全てのリンクのhrefを確認
    // allLinks.forEach((link, index) => {
    //   console.log(`Link ${index}:`, link.href, link.getAttribute('href'));
    // });
    
    // ページ内リンクを取得（より柔軟なセレクタ）
    const internalLinks = document.querySelectorAll('a[href*="#"]');
    
    // console.log('SmoothScroll initialized with links:', internalLinks.length);
    
    internalLinks.forEach(link => {
      const href = link.getAttribute('href');
      const currentDomain = window.location.origin;
      const currentPath = window.location.pathname;
      
      // 内部リンクの判定を改善
      const isInternalLink = href && href.includes('#') && href !== '#' && (
        // 相対パス（#から始まる）
        href.startsWith('#') ||
        // 同一ドメインかつ同一パスのハッシュ付きURL
        (href.startsWith(currentDomain) && href.includes('#') && this.isSamePage(href, currentPath)) ||
        // httpで始まらない相対パス
        (!href.startsWith('http'))
      );
      
      if (isInternalLink) {
        // console.log('Adding listener to:', link.href, 'getAttribute:', href);
        link.addEventListener('click', (e) => {
          console.log('Link clicked:', e.currentTarget.href);
          this.handleInternalLink(e);
        });
      }
    });
  }

  // 同一ページかどうかを判定
  isSamePage(href, currentPath) {
    try {
      const url = new URL(href, window.location.origin);
      const linkPath = url.pathname;
      
      // パスを正規化（末尾のスラッシュを統一）
      const normalizePath = (path) => {
        if (path === '/') return '/';
        return path.endsWith('/') ? path : path + '/';
      };
      
      const normalizedCurrentPath = normalizePath(currentPath);
      const normalizedLinkPath = normalizePath(linkPath);
      
      // console.log('Comparing paths:', normalizedCurrentPath, 'vs', normalizedLinkPath);
      return normalizedCurrentPath === normalizedLinkPath;
    } catch (e) {
      // console.warn('Error parsing URL:', href, e);
      return false;
    }
  }

  // Hamburgerインスタンスを設定
  setHamburger(hamburger) {
    this.hamburger = hamburger;
  }

  handleInternalLink(e) {
    // console.log('handleInternalLink called');
    e.preventDefault();
    
    const href = e.currentTarget.getAttribute('href');
    
    // ハッシュ部分を抽出（完全URLの場合も対応）
    let targetId;
    if (href.includes('#')) {
      targetId = href.split('#')[1]; // ハッシュ以降を取得
    } else {
      // console.warn('No hash found in href:', href);
      return;
    }
    
    const targetElement = document.getElementById(targetId);
    
    // console.log('Target ID:', targetId);
    // console.log('Target element:', targetElement);
    
    if (!targetElement) {
      // console.warn(`Target element with id "${targetId}" not found`);
      return;
    }

    // メニュー内のリンクかどうかを判定（クラス名で判定）
    const isMenuLink = e.currentTarget.classList.contains('g-menu-navigation-unit__inner');
    // console.log('Is menu link:', isMenuLink);
    // console.log('Hamburger exists:', !!this.hamburger);
    // console.log('Hamburger is open:', this.hamburger ? this.hamburger.isOpen : 'N/A');
    
    // メニューが開いている場合は閉じる
    if (isMenuLink && this.hamburger && this.hamburger.isOpen) {
      // console.log('Closing menu and scrolling');
      this.hamburger.toggleMenu();
      
      // メニューが閉じるアニメーション後にスクロール実行
      setTimeout(() => {
        this.scrollToElement(targetElement);
      }, 300); // メニューのアニメーション時間を考慮
    } else {
      // 通常のスムーススクロール実行
      // console.log('Direct scrolling');
      this.scrollToElement(targetElement);
    }
  }

  scrollToElement(element) {
    const headerHeight = this.getHeaderHeight();
    const elementTop = element.offsetTop;
    // const offsetPosition = elementTop - headerHeight;
    const offsetPosition = elementTop;

    // console.log('Scrolling to element:', element);
    // console.log('Header height:', headerHeight);
    // console.log('Element top:', elementTop);
    // console.log('Offset position:', offsetPosition);

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }

  getHeaderHeight() {
    const header = document.querySelector('.st-header');
    return header ? header.offsetHeight : 0;
  }
}

export default SmoothScroll;
